export const IMAGES = {
  heroAbstract: "https://images.unsplash.com/photo-1758685845872-4edbf0e76014?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  olympiad: "https://images.unsplash.com/photo-1719159381916-062fa9f435a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  curriculum: "https://images.unsplash.com/photo-1758685845872-4edbf0e76014?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  corporate: "https://images.unsplash.com/photo-1758518731468-98e90ffd7430?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aboutFeature: "https://images.unsplash.com/photo-1761208662734-fb46f1398551?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  map: "https://images.unsplash.com/photo-1524661135-423995f22d0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const TEAM = [
  {
    name: "Dr. Arya Wibawa",
    role: "Direktur Akademik & Pakar Kompetensi Eksakta",
    desc: "Merancang blueprint pembinaan olimpiade yang telah mengantar ratusan siswa ke panggung nasional.",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
  {
    name: "Sinta Larasati, M.Sc.",
    role: "Kepala Kurikulum & Silabus",
    desc: "Menerjemahkan konsep kompleks menjadi modul pembelajaran yang terstruktur dan terukur.",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
  {
    name: "Reza Adiputra",
    role: "Instruktur Logika & Pemrograman",
    desc: "Membangun nalar algoritmik siswa lewat pendekatan problem-solving yang menantang.",
    img: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
  {
    name: "Maya Prawira",
    role: "Lead Corporate Training (B2B)",
    desc: "Mendesain program upskilling SDM yang berdampak langsung pada performa organisasi.",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  },
];

export const SERVICES = [
  {
    icon: "Trophy",
    title: "Pelatihan Intensif Olimpiade",
    desc: "Pembinaan terarah untuk kompetisi logika, matematika, dan sains eksakta dengan mentor berpengalaman dan sistem tryout berkala.",
    points: ["Kurikulum bertingkat", "Simulasi kompetisi", "Analisis performa personal"],
  },
  {
    icon: "BookOpenCheck",
    title: "Pengembangan Kurikulum & Silabus",
    desc: "Penyusunan modul, silabus, dan blueprint pembelajaran yang terukur untuk sekolah maupun lembaga pendidikan mitra.",
    points: ["Modul berbasis kompetensi", "Blueprint asesmen", "Pendampingan implementasi"],
  },
  {
    icon: "Building2",
    title: "B2B Corporate Training & Sertifikasi",
    desc: "Program upskilling SDM korporat untuk memaksimalkan potensi tim, dilengkapi asesmen dan sertifikasi resmi.",
    points: ["Analisis kebutuhan", "Pelatihan tailor-made", "Sertifikasi terukur"],
  },
];

export const STATS = [
  { value: 1200, suffix: "+", label: "Siswa Terlatih" },
  { value: 65, suffix: "+", label: "Perusahaan Mitra" },
  { value: 140, suffix: "+", label: "Modul & Blueprint" },
  { value: 320, suffix: "+", label: "Prestasi Diraih" },
];

export const PARTNERS = [
  "TELKOM", "ASTRA", "PERTAMINA", "BCA", "GOJEK", "MANDIRI", "PLN", "UNILEVER",
];

export const GALLERY = [
  { img: "https://images.unsplash.com/photo-1652305500057-0fcb348b62aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: true, alt: "Suasana ujian kompetisi" },
  { img: "https://images.unsplash.com/photo-1758691736548-073bc97cdff4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: false, alt: "Sesi presentasi corporate training" },
  { img: "https://images.unsplash.com/photo-1665680674724-3a3b3368e036?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: false, alt: "Trofi penghargaan juara" },
  { img: "https://images.unsplash.com/photo-1761208662734-fb46f1398551?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: true, alt: "Instruktur membimbing siswa" },
  { img: "https://images.unsplash.com/photo-1758691736067-b309ee3ef7b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: false, alt: "Workshop di ruang konferensi" },
  { img: "https://images.unsplash.com/photo-1719159381916-062fa9f435a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: true, alt: "Kelas pembinaan olimpiade" },
  { img: "https://images.unsplash.com/photo-1667967699372-1c26d40dec46?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: false, alt: "Koleksi medali dan trofi" },
  { img: "https://images.unsplash.com/photo-1758518731468-98e90ffd7430?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", tall: false, alt: "Tim profesional mitra korporat" },
];

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Experience", href: "#experience" },
  { label: "Gallery", href: "#gallery" },
  { label: "Berita", href: "#news" },
  { label: "Contact", href: "#contact" },
];